@if (state().loading) {
<div class="loading-container" [style]="combinedOverlayStyle()" (click)="onClick($event)">
  <div class="flex flex-col items-center bg-gray-800 p-10 rounded-xl">
    @if (state().showSpinner){
      <taspinner [size]="state().spinnerSize ?? 'md'" ></taspinner>
    }
  @if (!!state().message){
    <div class="text-gray-50" [style]="combinedMessageStyle()">
      {{state().message}}
    </div>
  }
  </div>
</div>
}

@if (!!config() && config()!.loading){
  <div class="inline-flex">
    <div class="flex flex-col items-center">
        <taspinner [size]="config()!.spinnerSize ?? 'md'" ></taspinner>
      @if (!!config()!.message){
        <div class="text-gray-900" [style]="combinedMessageStyle()">
          {{config()!.message}}
        </div>
      }
    </div>
  </div>
}
